import { baseColors } from "@Constants/baseStyles"
import * as React from "react"
import Svg, { Rect, Path } from "react-native-svg"

const SvgSupport = (props) => {
    return (
        <Svg xmlns="http://www.w3.org/2000/svg" width={48} height={48} fill="none" viewBox="0 0 48 48" {...props}>
            <Rect width={48} height={48} fill="#fff" rx={10} />
            <Path
                fill={baseColors.green.primary}
                d="M23.694 27.407c-.572 0-1.035.477-1.035 1.049 0 .558.45 1.048 1.035 1.048s1.048-.49 1.048-1.049c0-.571-.476-1.048-1.048-1.048zm.176-7.938c-1.837 0-2.681 1.09-2.681 1.824 0 .531.449.777.816.777.736 0 .436-1.049 1.825-1.049.68 0 1.225.3 1.225.926 0 .735-.762 1.157-1.211 1.539-.395.34-.913.898-.913 2.07 0 .707.19.912.75.912.666 0 .802-.3.802-.559 0-.708.014-1.116.763-1.702.368-.286 1.525-1.212 1.525-2.492s-1.157-2.246-2.9-2.246z"
            />
            <Path
                fill={baseColors.green.primary}
                d="M24 14c-5.527 0-10 4.473-10 10v9.219c0 .431.35.781.781.781H24c5.527 0 10-4.473 10-10s-4.473-10-10-10zm0 18.438h-8.438V24A8.433 8.433 0 0124 15.562 8.433 8.433 0 0132.438 24 8.433 8.433 0 0124 32.438z"
            />
        </Svg>
    )
}

export default SvgSupport
